import { render, staticRenderFns } from "./MedicalPaymentsHistory.vue?vue&type=template&id=215758f2&scoped=true&"
import script from "./MedicalPaymentsHistory.vue?vue&type=script&lang=js&"
export * from "./MedicalPaymentsHistory.vue?vue&type=script&lang=js&"
import style0 from "./MedicalPaymentsHistory.vue?vue&type=style&index=0&id=215758f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215758f2",
  null
  
)

export default component.exports